export type SettingsPasswordErrorId = 'no_match';

export class SettingsPasswordError extends Error {
  public readonly id: SettingsPasswordErrorId;

  constructor(id: SettingsPasswordErrorId) {
    super(id);
    this.name = 'SettingsPasswordError';
    this.id = id;
    Object.setPrototypeOf(this, SettingsPasswordError.prototype);
  }
}
